import React, { useState } from 'react';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const GoogleTranslator = ({ language, setLanguage, show, className }: { language: string, setLanguage: (lang: string) => void, show: boolean, className?: string }) => {
    const [rightPosition, setRightPosition] = useState(0);
    const location = useLocation();
    const resizeFunction = () => {
        const containers = document.getElementsByClassName('container');
        if (containers.length > 0) {
            if (window.innerWidth >= 1199) {
                const halfContainerWidth = window.innerWidth - containers[0].clientWidth;
                setRightPosition(230 + halfContainerWidth / 2)
            }
            else {
                setRightPosition(0)
            }
        }
    }

    const getElementSelector: any = (element: any) => {
        if (element.id) {
            return `#${element.id}`;
        }
        if (element.classList && element.classList.length > 0) {
            return `.${Array.from(element.classList).join('.')}`;
        }
        const parent = element.parentNode;
        if (!parent) {
            return element.tagName.toLowerCase();
        }
        const index = Array.from(parent.children).indexOf(element) + 1;
        return `${getElementSelector(parent)} > ${element.tagName.toLowerCase()}:nth-child(${index})`;
    }


    // const translateFunctionCustom = () => {
    //     console.log('tranl');
    //     const allElements = document.querySelectorAll('#root *'); // Select all elements in the DOM
    //     const textData: any = [];

    //     allElements.forEach((element: any) => {
    //         if (element.textContent.trim() !== '') {
    //             const selector = getElementSelector(element);
    //             textData.push({
    //                 selector: selector,
    //                 text: element.textContent.trim(),
    //                 html: element.innerHTML
    //             });
    //         }
    //     });


    // }

    useEffect(() => {
        // console.log('language', language)
        fire_event(language ? language : 'en');

    }, [language])

    const fire_event = (value: string, event: any = 'change') => {
        try {
            let call_intenal = (element: any) => {
                if ((document as any).createEventObject) {
                    var evt = (document as any).createEventObject();
                    element.fireEvent('onchange', evt)
                } else {
                    var evt = (document as any).createEvent('HTMLEvents');
                    evt.initEvent('change', true, true);
                    element.dispatchEvent(evt)
                }
            }
            var teCombo: any;
            var sel = document.getElementsByTagName('select');
            for (var i = 0; i < sel.length; i++)
                if (sel[i].className.indexOf('goog-te-combo') != -1) {
                    teCombo = sel[i];
                    break;
                }
            if (document.getElementsByClassName("goog-te-combo") == null) {
                setTimeout(function () {
                    fire_event(value, event);
                }, 500)
            } else {
                teCombo.value = value;
                call_intenal(teCombo)
            }
        } catch (e) { }
    }

    useEffect(() => {
        if (!(window as any).googleTranslateElementInit) {
            (window as any).googleTranslateElementInit = () => {
                new (window as any).google.translate.TranslateElement(
                    {
                        includedLanguages: "en,es",
                        layout: (window as any).google.translate.TranslateElement.InlineLayout.HORIZONTAL,
                    },
                    "google_translate_element",
                );
            };
        }

        if (!document.querySelector('script[src="//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit"]')) {
            const script = document.createElement("script");
            script.type = "text/javascript";
            script.src = "//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit";
            document.head.appendChild(script);
        }

        if (!document.querySelector("style[data-google-translate-style]")) {
            const style = document.createElement("style");
            style.setAttribute("data-google-translate-style", "true");
            style.innerHTML = `
                    .goog-te-gadget-simple {background-color:#FFF;border:none;font-size:11px;}
                    .goog-te-gadget-simple img {display:none;}
                `;
            document.head.appendChild(style);
        }

        const htmlElement = document.documentElement;
        setLanguage(htmlElement.getAttribute('lang') || 'en');

        // 2. Setup observer to watch for attribute changes
        const observer = new MutationObserver(() => {
            const currentLang = htmlElement.getAttribute('lang') || 'en';
            setLanguage(currentLang);
            resizeFunction()
        });

        observer.observe(htmlElement, {
            attributes: true,
            attributeFilter: ['lang', 'class'], // Google often toggles classes too
        });

        window.addEventListener("resize", () => {
            resizeFunction()
        });


        // translateFunctionCustom();

        window.onload = function () {
            // Code to execute after the entire page has loaded
            console.log('Window onload event fired!');

            // setTimeout(() => {
            //     var current_lang = document?.querySelector('html')?.getAttribute('lang') || 'en';
            //     setLanguage(current_lang);
            // }, 5000);

            const btn: any = document.getElementsByClassName("goog-te-combo");
            console.log("btn", btn, btn[0]?.value);
            if (btn && btn.length > 0) {

                btn[0].addEventListener("change", function (event: any) {
                    // console.log("Element clicked!", event.target.value);
                    setLanguage(event.target.value);
                });

            }
        };

        window.addEventListener('pageshow', (event) => {
            if (event.persisted) {
                console.log('pageshow - persisted')
                window.location.reload();
            }
        });

        console.log('mount')
        return (() => {
            observer.disconnect();
            console.log('unmount')
            window.removeEventListener("resize", () => {
                resizeFunction()
            })
            window.removeEventListener("pageshow", (event) => {
                if (event.persisted) {
                    console.log('pageshow - removed')
                    window.location.reload();
                }
            });
        })


    }, [location.pathname]);

    const rightPos = show && className == 'dashboard-translate' && rightPosition ? rightPosition : '';


    return <>
        {/* <button onClick={() => { fire_event('es'); }}>change</button> */}
        <div id="google_translate_element" className={className ? className : 'home-translate'} style={{ right: rightPos, display: !show ? 'none' : '' }}></div>
    </>;

    // return <></>

};

export default GoogleTranslator;